import { render, staticRenderFns } from "./ModalEditDescription.vue?vue&type=template&id=d4ebdeba&scoped=true"
import script from "./ModalEditDescription.vue?vue&type=script&lang=js"
export * from "./ModalEditDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ebdeba",
  null
  
)

export default component.exports